import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS,
  TOGGLE_NOTIFICATION_READ_UNREAD,
  DELETE_NOTIFICATION,
} from "./actionTypes"

import {
  getNotificationsSuccess,
  getNotificationsFail,
  loadMoreNotificationsSuccess,
  loadMoreNotificationsFail,
  toggleNotificationReadUnreadSuccess,
  toggleNotificationReadUnreadFail,
  deleteNotificationSuccess,
  deleteNotificationFail,
} from "./actions"

import {
  getNotifications,
  manageNotification,
  toggleNotificationReadUnread,
} from "../../helpers/backend_helper"

// GET NOTIFICATIONS SAGA
function* fetchNotifications({ payload: { options } }) {
  try {
    const response = yield call(getNotifications, options)
    yield put(getNotificationsSuccess(response))
  } catch (error) {
    yield put(getNotificationsFail(error))
  }
}

// LOAD MORE NOTIFICATIONS SAGA
function* loadMoreNotifications({ payload: { options } }) {
  try {
    const response = yield call(getNotifications, options)
    yield put(loadMoreNotificationsSuccess(response))
  } catch (error) {
    yield put(loadMoreNotificationsFail(error))
  }
}

// TOGGLE NOTIFICATION READ/UNREAD SAGA
function* onToggleNotificationReadUnread({ payload: { notificationIDs } }) {
  try {
    const response = yield call(toggleNotificationReadUnread, {
      notificationIDs,
    })
    yield put(toggleNotificationReadUnreadSuccess({ ...response, notificationIDs }))
  } catch (error) {
    yield put(toggleNotificationReadUnreadFail(error))
  }
}

// DELETE NOTIFICATION SAGA
function* onDeleteNotification({ payload: { notificationIDs } }) {
  try {
    const response = yield call(manageNotification, {
      actionType: "delete",
      notificationIDs,
    })
    yield put(deleteNotificationSuccess({ ...response, notificationIDs }))
  } catch (error) {
    yield put(deleteNotificationFail(error))
  }
}

function* notificationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, fetchNotifications)
  yield takeEvery(LOAD_MORE_NOTIFICATIONS, loadMoreNotifications)
  yield takeEvery(TOGGLE_NOTIFICATION_READ_UNREAD, onToggleNotificationReadUnread)
  yield takeEvery(DELETE_NOTIFICATION, onDeleteNotification)
}

export default notificationsSaga